module.exports = __webpack_public_path__ + "img/jas_logo (1).9f289dd8.png";